import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import instance from "../../ApiInstance/Inetrceptor";
import {
  CircularProgress,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import DetailedDialog from "./KeyDetails";

const Original_message = ({
  open,
  handleClose,
  originalMessageId,
  sourceEndpointName,
  selectedDirection,
}) => {
  const [totalRecords, setTotalRecords] = useState(0);
  const [loader, setLoader] = useState(true);
  const [OriginalMessageTableData, setOriginalMessageTableData] = useState({});
  const [selectedKey, setSelectedKey] = useState(null); // State to manage selected key
  const [direction, setDirection] = useState(null);
  const [jobref, setJobref] = useState(null);
  const [detailedDialogOpen, setDetailedDialogOpen] = useState(false); // State to manage detailed dialog open state

  const getMessageLogRecords = () => {
    const body = {
      id: originalMessageId,
      selected_direction: selectedDirection,
    };
    instance
      .post("api/v1/Message/GetMessageTimeline", body)
      .then((res) => {
        if (res?.data?.Success) {
          const value = res?.data?.Value;
          const timelineData = Object.keys(value).map((key) => ({
            key,
            toTimeline: value[key].to_timeline,
            froTimeline: value[key].fro_timeline,
          }));
          setOriginalMessageTableData(timelineData);
          console.log("timelineData", timelineData);
          setTotalRecords(res?.data?.Records ?? 0);
        } else {
          setTotalRecords(0);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
      });
  };
  // const renderStatus1Fields = (status1) => {
  //   return Object.keys(status1).map((field, index) => (
  //     <div key={index}>
  //       {field}: {status1[field]}
  //     </div>
  //   ));
  // };
  const renderStatus1Fields = (status1, jobReference) => {
    return Object.keys(status1).map((field, index) => (
      <div key={index}>
        <strong>{field.replace(/_/g, " ")}: </strong>
        {field === "Status1 Original Message Identifier" && status1[field] ? (
          <span
            style={{ cursor: "pointer", textDecoration: "underline" }}
            onClick={() =>
              handleKeyClick({
                key: status1[field],
                Direction: "T",
                Job_Reference: `${status1["Custom Reference#"]}_${jobReference}`,
              })
            }
          >
            {status1[field]}
          </span>
        ) : (
          status1[field]
        )}
      </div>
    ));
  };
  useEffect(() => {
    getMessageLogRecords();
  }, [originalMessageId, selectedDirection]);

  const handleKeyClick = ({ key, Direction, Job_Reference }) => {
    setSelectedKey(key); // Set the selected key
    setDirection(Direction);
    setJobref(Job_Reference);
    setDetailedDialogOpen(true); // Open the detailed dialog
  };

  const handleDetailedDialogClose = () => {
    setDetailedDialogOpen(false); // Close the detailed dialog
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        maxWidth="md"
        fullWidth={true}
        sx={{ "& .MuiDialog-paper": { width: "70%", maxWidth: "none" } }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: "1.5rem",
          }}
        >
          <span style={{ textAlign: "center", flex: 1 }}>Message Details</span>
          <IconButton onClick={handleClose} sx={{ marginRight: "-12px" }}>
            <CancelIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {loader ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100px",
                }}
              >
                <CircularProgress />
              </div>
            ) : totalRecords === 0 ? (
              <div style={{ textAlign: "center", paddingTop: "1rem" }}>
                <strong>No data found</strong>
              </div>
            ) : (
              OriginalMessageTableData.length > 0 &&
              OriginalMessageTableData.map((timeline, index) => (
                <div key={index}>
                  <strong>Key : </strong>
                  <span
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                    onClick={() =>
                      handleKeyClick({
                        key: timeline.key,
                        Direction: "T",
                        Job_Reference: timeline.toTimeline?.job_reference,
                      })
                    } // Add click handler to open detailed dialog
                  >
                    {timeline.key}
                  </span>
                  {timeline.toTimeline && (
                    <div>
                      <strong>To Timeline :</strong>
                      <br />
                      Trucker ID: {timeline.toTimeline.trucker_id}
                      <br />
                      Sent to Batch:{" "}
                      {timeline.toTimeline.sent_to_batch ? "Yes" : "No"}
                      <br />
                      Batch Number: {timeline.toTimeline.batch_number}
                      <br />
                      Response Status Code:{" "}
                      {timeline.toTimeline.current_response_msg_status_code}
                      <br />
                      Response Status Time:{" "}
                      {timeline.toTimeline.current_response_msg_status_time}
                      <br />
                      Creation Timestamp:{" "}
                      {timeline.toTimeline.creation_timestamp}
                      <br />
                      Job Reference: {timeline?.toTimeline?.job_reference}
                      <br />
                      Scheduled Process Time:{" "}
                      {timeline.toTimeline.scheduled_process_time}
                      <br />
                      Message Creation Timestamp:{" "}
                      {timeline.toTimeline.message_creation_timestamp}
                      <br />
                      Message Filepath: {timeline.toTimeline.message_filepath}
                      <br />
                      <strong>Status_1 :</strong>
                      {renderStatus1Fields(
                        timeline.toTimeline.status_1,
                        timeline?.toTimeline?.job_reference
                      )}
                    </div>
                  )}
                  <br />
                  {timeline.froTimeline && timeline.froTimeline.length > 0 && (
                    <div>
                      <strong>Fro Timeline :</strong>
                      <br />
                      <br />
                      <TableContainer component={Paper} sx={{ maxHeight: 300 }}>
                        <Table stickyHeader>
                          <TableHead>
                            <TableRow>
                              <TableCell>Message Identifier</TableCell>
                              <TableCell>Response Message Code</TableCell>
                              <TableCell>Response Generated At</TableCell>
                              <TableCell>Response Posted on SFTP At</TableCell>
                              <TableCell>Message FRO ID</TableCell>
                              <TableCell>Job Reference</TableCell>
                              <TableCell>Message Creation Timestamp</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {timeline.froTimeline.map((item, idx) => (
                              <TableRow key={idx}>
                                <TableCell>
                                  <span
                                    style={{
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                    }}
                                    onClick={() =>
                                      handleKeyClick({
                                        key: item.message_identifier,
                                        Direction: "F",
                                        Job_Reference: item?.job_reference,
                                      })
                                    } // Add click handler to open detailed dialog
                                  >
                                    {item?.message_identifier}
                                  </span>
                                </TableCell>
                                <TableCell>
                                  {item?.response_message_code}
                                </TableCell>
                                <TableCell>
                                  {item?.response_generated_at}
                                </TableCell>
                                <TableCell>
                                  {item?.response_posted_on_SFTP_at}
                                </TableCell>
                                <TableCell>{item?.message_fro_id}</TableCell>
                                <TableCell>{item?.job_reference}</TableCell>
                                <TableCell>
                                  {item?.message_creation_timestamp}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  )}
                </div>
              ))
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="secondary" onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Detailed Dialog */}
      {selectedKey && (
        <DetailedDialog
          open={detailedDialogOpen}
          handleClose={handleDetailedDialogClose}
          keyData={selectedKey}
          Direction={direction}
          Job_ref={jobref}
        />
      )}
    </>
  );
};
export default Original_message;
